// extracted by mini-css-extract-plugin
export var bgImage = "header-episode-module--bgImage--4ff06";
export var containerHeader = "header-episode-module--containerHeader--8d508";
export var excerpt = "header-episode-module--excerpt--72c92";
export var header = "header-episode-module--header--30690";
export var topic = "header-episode-module--topic--63118";